import axios from "axios";
// let locationorigin = window.location.origin;
// let regexpatt = /\W?\d*$/;
// let windowobj = locationorigin.replace(regexpatt, "");

const apiClient = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? `${process.env.VUE_APP_LOCAL_API_ORIGIN}`
      : `${process.env.VUE_APP_LIVE_API_ORIGIN}`,
  headers: { Pragma: "no-cache", "Cache-Control": "no-store" }
});

const apiClientV2 = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? `${process.env.VUE_APP_LOCAL_API_V2_ORIGIN}`
      : `${process.env.VUE_APP_LIVE_API_V2_ORIGIN}`,
  headers: {
    Pragma: "no-cache",
    "Cache-Control": "no-store"
  }
});

export default {
  addinstitution(institutionObj) {
    return apiClient.post("/admin.class.php", {
      action: "Add-Institution",
      institutionObj
    });
  },

  checkquestion(quest) {
    return apiClient.get(
      "/admin.class.php/?quest=" +
        quest.question +
        "&categ=" +
        quest.category +
        "&insti=" +
        quest.institution +
        "&subject=" +
        quest.subject
    );
  },
  addQuestion(questionObj) {
    return apiClient.post("/admin.class.php", {
      action: "add-question",
      questionObj
    });
  },

  getQuestions(trackid) {
    return apiClient.get("admin.class.php/?get=all&name=" + trackid);
  },

  getQuestion(trackid) {
    return apiClient.get("admin.class.php/?get=single&trackid=" + trackid);
  },

  updateSQuestion(questionObj) {
    return apiClient.post("/admin.class.php", {
      action: "Update Question",
      questionObj
    });
  },

  getInstitutions(orgname, orgId, query) {
    return apiClient.post(`/admin.class.php?${query}`, {
      action: "get-all-institutions",
      orgname,
      orgId
    });
  },
  getInstitutionsTable(orgname, orgId, query) {
    return apiClient.post(`/admin.class.php?${query}`, {
      action: "get-institutions-table",
      orgname,
      orgId
    });
  },
  getTestgroupsAnalytics(orgId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "get-testgroups-analytics",
      orgId
    });
  },

  getCategories(orgname) {
    return apiClient.post("/admin.class.php", {
      action: "get-categories",
      orgname
    });
  },

  getInstitution(trackid) {
    return apiClient.get("admin.class.php/?geti=single&trackid=" + trackid);
  },

  updateSInstitution(institutionObj) {
    return apiClient.post("/admin.class.php", {
      action: "Update Institution",
      institutionObj
    });
  },
  deleteInstitution(institution_id) {
    return apiClient.post(`/admin.class.php`, {
      action: "delete-institution",
      institution_id
    });
  },
  sendCombo(comboObj) {
    return apiClient.post("/admin.class.php", {
      action: "Add Combo",
      comboObj
    });
  },
  getCounters() {
    return apiClient.get("admin.class.php/?get=counts");
  },
  sendImage(formData) {
    return apiClient.post("filehandler.php", {
      formData
    });
  },
  sendEmail(emailObj) {
    return apiClient.post("emailer.class.php", {
      action: "email-users",
      emailObj
    });
  },
  allUsers() {
    return apiClient.get("admin.class.php/?get=users");
  },
  addAdminu(userObj) {
    return apiClient.post("admin.class.php", {
      action: "add-admin",
      userObj
    });
  },
  altDelete(delobj) {
    return apiClient.post("admin.class.php", {
      action: "Delete",
      delobj
    });
  },
  altDeleteTopic(delobj) {
    return apiClient.post("admin.class.php", {
      action: "delete-topic",
      delobj
    });
  },
  getStatisticsStock(queryobj) {
    return apiClient.post("admin.class.php", {
      action: "general-stock-stat",
      queryobj
    });
  },
  getStocks(trackid) {
    return apiClient.get("admin.class.php/?get=stock&trackid=" + trackid);
  },
  getQuestionsall() {
    return apiClient.get("admin.class.php/?get=allq");
  },
  chngAvailable(chngobj) {
    return apiClient.post("admin.class.php", {
      action: "chngquestion",
      chngobj
    });
  },
  getQStocked() {
    return apiClient.get("admin.class.php/?get=qstocked");
  },
  getQsStocked(qsobj) {
    return apiClient.post("admin.class.php", {
      action: "questocked",
      qsobj
    });
  },

  getQsSStocked(qssobj) {
    return apiClient.post("admin.class.php", {
      action: "quesstocked",
      qssobj
    });
  },

  getForQuestions(queryObj) {
    return apiClient.post("admin2.class.php", {
      action: "questions-for",
      queryObj
    });
  },

  getForStocks(stockObj) {
    return apiClient.post("admin2.class.php", {
      action: "for-stocks",
      stockObj
    });
  },
  addTopicsApi(topicObj) {
    return apiClient.post("admin2.class.php", {
      action: "add-topic-text",
      topicObj
    });
  },
  addTypeApi(typeObj) {
    return apiClient.post("admin2.class.php", {
      action: "add-category",
      typeObj
    });
  },
  addTopicsFileApi(topicFileObj) {
    return apiClient.post("admin2.class.php", {
      action: "add-topic-file",
      topicFileObj
    });
  },
  addQuestionsFileApi(questionFileObj) {
    return apiClient.post("admin2.class.php", {
      action: "add-question-file",
      questionFileObj
    });
  },
  updateServicecategory(categoryObj) {
    return apiClient.post("/admin2.class.php", {
      action: "update-category",
      categoryObj
    });
  },
  getAllTopics(orgname) {
    return apiClient.post("/admin2.class.php", {
      action: "get-all-topics",
      orgname
    });
  },
  getTopicStocks(orgname) {
    return apiClient.post("/admin2.class.php", {
      action: "get-topic-stocks",
      orgname
    });
  },
  getForTopics(queryObj) {
    return apiClient.post("admin2.class.php", {
      action: "topics-for-table",
      queryObj
    });
  },

  getForTopicStocks(stockObj) {
    return apiClient.post("admin2.class.php", {
      action: "for-topic-stocks",
      stockObj
    });
  },
  updateServiceTopic(topicObj) {
    return apiClient.post("/admin2.class.php", {
      action: "update-topic",
      topicObj
    });
  },
  publishServiceBlogpost(postObj) {
    return apiClient.post("/admin2.class.php", {
      action: "publish-post",
      postObj
    });
  },
  saveServiceBlogdraft(draftObj) {
    return apiClient.post("/admin2.class.php", {
      action: "save-draft",
      draftObj
    });
  },
  getAllBlogs() {
    return apiClient.post("/admin2.class.php", {
      action: "get-all-blogs"
    });
  },
  getBlogStocks() {
    return apiClient.post("/admin2.class.php", {
      action: "get-blog-stocks"
    });
  },
  saveServiceBlogpostChanges(postObj) {
    return apiClient.post("/admin2.class.php", {
      action: "edit-blogpost",
      postObj
    });
  },
  getAllBlogdrafts() {
    return apiClient.post("/admin2.class.php", {
      action: "get-all-blogdrafts"
    });
  },
  getBlogdraftsStocks() {
    return apiClient.post("/admin2.class.php", {
      action: "get-blogdrafts-stocks"
    });
  },
  saveServiceBlogdraftChanges(draftObj) {
    return apiClient.post("/admin2.class.php", {
      action: "edit-blogdraft",
      draftObj
    });
  },
  addTestspace(testspaceObj) {
    return apiClient.post("/admin2.class.php", {
      action: "add-testspace",
      testspaceObj
    });
  },
  getTestspaces(orgname, orgId, query) {
    return apiClient.post(`/admin2.class.php?${query}`, {
      action: "get-testspaces",
      orgname,
      orgId
    });
  },
  getTestspacesAnalytics(orgId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "get-testspaces-analytics",
      orgId
    });
  },
  getTestspace(id) {
    return apiClient.post(`/admin2.class.php`, {
      action: "get-testspace",
      id
    });
  },
  getCompetitions(orgname, orgId, query) {
    return apiClient.post(`/admin2.class.php?${query}`, {
      action: "get-competitions",
      orgname,
      orgId
    });
  },
  getCompetition(id) {
    return apiClient.post(`/admin2.class.php`, {
      action: "get-competition",
      id
    });
  },
  updateSTestspace(testspaceobj) {
    return apiClient.post("/admin2.class.php", {
      action: "update-testspace",
      testspaceobj
    });
  },
  getOrganization(orgname) {
    return apiClient.post("/admin2.class.php", {
      action: "get-organization",
      orgname
    });
  },
  getOrganizationplan(orgname) {
    return apiClient.post("/admin2.class.php", {
      action: "get-organization-plan",
      orgname
    });
  },
  setOrganization(orgObj) {
    return apiClient.post("/admin2.class.php", {
      action: "set-organization",
      orgObj
    });
  },
  getSpacestats(spaceid) {
    return apiClient.post("/admin2.class.php", {
      action: "get-space-stats",
      spaceid
    });
  },
  getSpaceresults(spaceid) {
    return apiClient.post("/admin2.class.php", {
      action: "get-space-results",
      spaceid
    });
  },
  getCompanymetrics() {
    return apiClient.post("/admin2.class.php", {
      action: "get-company-metrics"
    });
  },
  getOrgadmins(clearanceorg) {
    return apiClient.post("/admin2.class.php", {
      action: "get-organization-admins",
      clearanceorg
    });
  },
  removeAdmin(userObj) {
    return apiClient.post("/admin.class.php", {
      action: "remove-org-admin",
      userObj
    });
  },
  prepareResults(prepareObj) {
    return apiClient.post("/admin3.class.php", {
      action: "prepare-space-results",
      prepareObj
    });
  },
  DownloadResults(prepareObj) {
    return apiClient.post("/admin3.class.php", {
      action: "download-space-results",
      prepareObj,
      responseType: "blob"
    });
  },
  performSpaceclear(spacetrackid) {
    return apiClient.post("/admin3.class.php", {
      action: "perform-clear-space",
      spacetrackid
    });
  },
  performSpacedelete(spacetrackid) {
    return apiClient.post("/admin3.class.php", {
      action: "perform-delete-space",
      spacetrackid
    });
  },
  performSpacetruncate(spacetrackid) {
    return apiClient.post("/admin3.class.php", {
      action: "perform-truncate-space",
      spacetrackid
    });
  },
  flushOutQuestions(stockObj) {
    return apiClient.post("/admin3.class.php", {
      action: "flush-for-questions",
      stockObj
    });
  },
  prepareDownloadQuestions(stockObj) {
    return apiClient.post("/admin3.class.php", {
      action: "prepare-txt-questions",
      stockObj
    });
  },
  getPartnerships() {
    return apiClient.post("/admin3.class.php", {
      action: "get-partnerships"
    });
  },
  checkPartnerOrganization(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "check-partner-organization",
      payload
    });
  },

  generatePartnerCode(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "generate-partnership-code",
      payload
    });
  },
  createePartnership(payload) {
    return apiClient.post("/admin2.class.php", {
      action: "create-partnerships",
      payload
    });
  },
  checkCouponcode(couponcode) {
    return apiClient.post("/admin3.class.php", {
      action: "check-coupon-code",
      couponcode
    });
  },
  getCoupons(admintrackid, clearance_level) {
    return apiClient.post("/admin3.class.php", {
      action: "get-coupons",
      admintrackid,
      clearance_level
    });
  },
  setCoupons(couponObj) {
    return apiClient.post("/admin3.class.php", {
      action: "add-coupons",
      couponObj
    });
  },
  updateCoupons(couponObj) {
    return apiClient.post("/admin3.class.php", {
      action: "update-coupons",
      couponObj
    });
  },

  deleteCoupon(couponObj) {
    return apiClient.post("/admin3.class.php", {
      action: "delete-coupon",
      couponObj
    });
  },
  getAmbassadors() {
    return apiClient.post("/admin3.class.php", {
      action: "get-ambassadors"
    });
  },
  checkAmbassadorcode(ambassadorcode) {
    return apiClient.post("/admin3.class.php", {
      action: "check-ambassador-code",
      ambassadorcode
    });
  },
  setAmbassadors(ambassadorObj) {
    return apiClient.post("/admin3.class.php", {
      action: "add-ambassadors",
      ambassadorObj
    });
  },
  updateAmbassadors(ambassadorObj) {
    return apiClient.post("/admin3.class.php", {
      action: "update-ambassadors",
      ambassadorObj
    });
  },
  setPaidpayout(payoutObj) {
    return apiClient.post("/admin3.class.php", {
      action: "paid-payout",
      payoutObj
    });
  },
  setApprovepayout(payoutObj) {
    return apiClient.post("/admin3.class.php", {
      action: "approve-payout",
      payoutObj
    });
  },
  setDisapprovepayout(payoutObj) {
    return apiClient.post("/admin3.class.php", {
      action: "disapprove-payout",
      payoutObj
    });
  },
  getContents(admintrackid, clearance_level) {
    return apiClient.post("/admin3.class.php", {
      action: "get-contents",
      admintrackid,
      clearance_level
    });
  },
  setContents(contentObj) {
    return apiClient.post("/admin3.class.php", {
      action: "add-contents",
      contentObj
    });
  },
  updateContents(contentObj) {
    return apiClient.post("/admin3.class.php", {
      action: "update-contents",
      contentObj
    });
  },
  deleteContent(contentObj) {
    return apiClient.post("/admin3.class.php", {
      action: "delete-content",
      contentObj
    });
  },
  sendoutContent(sendObj) {
    return apiClient.post("/admin3.class.php", {
      action: "send-content",
      sendObj
    });
  },
  getCampaigns() {
    return apiClient.post("/admin3.class.php", {
      action: "get-campaigns"
    });
  },
  continuingCampaign(trackid) {
    return apiClient.post("/admin3.class.php", {
      action: "continue-campaign",
      trackid
    });
  },
  $_getAllUsers() {
    return apiClient.post("/admin3.class.php", {
      action: "get-all-users"
    });
  },
  $_getDiscountDetails() {
    return apiClient.post("/admin3.class.php", {
      action: "get-discount-details"
    });
  },
  setDiscountSeason(discountObj) {
    return apiClient.post("/admin3.class.php", {
      action: "set-discount",
      discountObj
    });
  },
  createNotification(noti) {
    return apiClientV2.post("/notifications", noti);
  },
  getNotifications() {
    return apiClientV2.get("/notifications/admin/all");
  },
  setUpdateNotification(noti) {
    return apiClientV2.put("/notifications", noti);
  },
  deleteNotification(id) {
    return apiClientV2.delete(`/notifications/${id}`);
  },
  $_getOrgAnalytics(orgId) {
    return apiClient.post("/admin3.class.php", {
      action: "get-org-analytics",
      orgId
    });
  },
  createGroup(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "create-group",
      payload
    });
  },
  updateGroup(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "update-group",
      payload
    });
  },
  getGroupsTable(orgId, query) {
    return apiClient.post(`/admin3.class.php?${query}`, {
      action: "get-groups-table",
      orgId
    });
  },
  getGroupsAnalytics(orgId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "get-group-analytics",
      orgId
    });
  },
  getAllGroups(orgId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "get-all-org-groups",
      orgId
    });
  },
  getSingleGroup(groupId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "get-single-group",
      groupId
    });
  },
  deleteGroup(groupId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "delete-group",
      groupId
    });
  },
  truncateGroup(groupId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "truncate-group",
      groupId
    });
  },
  createCandidate(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "create-candidate",
      payload
    });
  },
  importCandidates(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "import-candidates",
      payload
    });
  },
  updateCandidate(payload) {
    return apiClient.post("/admin3.class.php", {
      action: "update-candidate",
      payload
    });
  },
  deleteCandidate(candidateId) {
    return apiClient.post("/admin3.class.php", {
      action: "delete-candidate",
      candidateId
    });
  },
  getCandidatesTable(groupId, query) {
    return apiClient.post(`/admin3.class.php?${query}`, {
      action: "get-candidates-table",
      groupId
    });
  },
  getAllCandidates(groupId, query = '') {
    return apiClient.post(`/admin3.class.php?${query}`, {
      action: "get-all-group-candidates",
      groupId
    });
  },
  getSingleCandidate(candidateId) {
    return apiClient.post(`/admin3.class.php`, {
      action: "get-single-candidate",
      candidateId
    });
  },
  downloadExampleFile(downloadType, fileType, environment) {
    return apiClient.post("/admin3.class.php", {
      action: "download-example-file",
      downloadType, 
      fileType, 
      environment
    });
  },
};
